const sharedPositionMap = {
  position: 'u-flexJustifyCenter',
  position2: 'u-flexJustifyStart',
  outerSize: 'u-sizeConstrained',
  innerSize: 'u-sizeFull',
  imageSize: 'u-sizeFull',
  subtitleSize: '',
  outerBackground: false,
  leftPosition: 0,
  rightPosition: null,
  paddingVert: 'u-paddingVert8gu u-sm-paddingVert4gu u-md-paddingVert4gu',
}

export const positionMap = {
  None: {
    ...sharedPositionMap,
    paddingVert: 'u-paddingVert4gu',
  },
  Top: {
    ...sharedPositionMap,
    position: 'u-flexJustifyStart u-paddingVert4gu',
  },
  Middle: {
    ...sharedPositionMap,
    position: 'u-flexJustifyCenter u-paddingVert4gu',
  },
  Bottom: {
    ...sharedPositionMap,
    position: 'u-flexJustifyEnd u-paddingVert4gu',
  },
  'Top Angled': {
    ...sharedPositionMap,
    position: 'u-flexJustifyStart',
    outerSize: '',
    innerSize: 'u-sizeFull slanted-div',
    subtitleSize:
      'u-textSecondary u-textSizeMsrp3 u-sm-textSizeMsrp2 u-md-textSizeMsrp3',
    paddingVert: 'u-paddingTop8gu',
  },
  Left: {
    ...sharedPositionMap,
    position: 'u-flexJustifyCenter u-paddingVert4gu',
    innerSize: 'u-md-size1of2 u-lg-size1of2',
    imageSize: 'u-sm-sizeFull u-md-size1of2 u-lg-size1of2',
    outerBackground: true,
    leftPosition: null,
    rightPosition: 0,
    paddingVert: 'u-paddingVert8gu u-sm-paddingVert4gu u-md-paddingVert4gu',
    paddingHoriz: 'u-paddingRight4gu u-sm-paddingRight0',
  },
  Right: {
    ...sharedPositionMap,
    position2: 'u-flexJustifyEnd',
    innerSize: 'u-md-size1of2 u-lg-size1of2',
    imageSize: 'u-sm-sizeFull u-md-size1of2 u-lg-size1of2',
    outerBackground: true,
    paddingVert: 'u-paddingVert8gu u-sm-paddingVert4gu u-md-paddingVert4gu',
    paddingHoriz: 'u-paddingLeft4gu u-sm-paddingLeft0',
  },
}

export const styleMap = {
  None: {},
  'Subheading Above': {},
  Callout: {
    textColor: 'u-textColorBrand',
    innerSize: 'u-size4of12 u-sm-sizeFull u-md-size1of2',
    imageSize: 'u-size1of2plus200 u-sm-sizeFull',
    videoSize: 'u-size8of12 u-sm-sizeFull u-md-size1of2',
    position: 'u-paddingVert0gu',
    backgroundSize: 'u-ml-backgroundContain',
    paddingVert: 'u-paddingVert8gu u-sm-paddingVert0 u-md-paddingVert4gu',
  },
  CalloutInList: {
    textColor: 'u-textColorBrand',
    outerSize: 'u-sizeConstrained u-sm-sizeConstrainedFlush',
    innerSize: 'u-size8of12 u-sm-sizeFull',
    imageSize: 'u-size4of12 u-sm-sizeFull callout-in-list-image',
    videoSize: 'u-size4of12 u-sm-sizeFull',
    position: 'u-sm-paddingVert4gu',
    backgroundSize: '',
    paddingVert: 'u-paddingVert8gu u-sm-paddingVert0 u-md-paddingVert4gu',
  },
  VideoBlog: {
    textColor: 'u-textColorBrand',
    innerSize: 'u-size5of12 u-sm-sizeFull u-md-size1of2',
    imageSize: 'u-size1of2plus200 u-sm-sizeFull',
    videoSize: 'u-size7of12 u-sm-sizeFull u-md-size1of2',
    position: 'u-sm-paddingVert4gu',
    backgroundSize: 'u-ml-backgroundContain',
    paddingVert: 'u-paddingVert8gu u-sm-paddingVert0 u-md-paddingVert4gu',
  },
  VideoBlogInList: {
    textColor: 'u-textColorBrand',
    outerSize: '',
    innerSize: 'u-size1of2 u-sm-sizeFull',
    imageSize: 'u-size1of2 u-sm-sizeFull',
    videoSize: 'u-size1of2 u-sm-sizeFull',
    position: 'u-sm-paddingVert4gu',
    backgroundSize: '',
    paddingVert: 'u-paddingVert8gu u-sm-paddingVert0 u-md-paddingVert4gu',
  },
  Quote: {
    textColor: 'u-textColorBrand',
    innerSize: 'u-size3of4 u-sm-sizeFull',
    textBackgroundColor: 'u-bgColorWhite',
    padding: 'u-padding8gu u-sm-paddingVert4gu u-md-paddingVert4gu',
    borderColor: 'u-borderLeftBrandLight u-boxShadow',
    subtitleSize: 'u-textSizeMsrp3',
    backgroundSize: '',
    paddingHoriz: 'u-paddingLeft8gu',
  },
  Card: {
    itemBackgroundColor: 'u-bgColorWhite',
  },
  Icon: {
    paddingVert:
      'u-paddingTop4gu u-paddingBottom8gu u-sm-paddingVert4gu u-md-paddingVert4gu',
  },
}

export const alignmentMap = {
  Left: {
    alignment: 'u-flexAlignItemsStart',
    textAlign: '',
    capitalization: '',
  },
  Center: {
    alignment: 'u-flexAlignItemsCenter',
    textAlign: 'u-textCenter',
    capitalization: 'u-textUppercase',
  },
}

const sharedButtonMap = {
  button: 'Link u-textColorBrandLight',
  append: 'brand',
  hover: 'u-posRelative hover-underline-animation',
}

export const buttonMap = {
  Left: {
    ...sharedButtonMap,
  },
  Center: {
    ...sharedButtonMap,
    button: 'Button Button--secondary u-textColorBrand',
    append: '',
    hover: '',
  },
}

export const layoutMap = {
  'Gallery Inset': {
    ...sharedButtonMap,
    button:
      'Button Button--secondary Button--reversed Button--block u-textCenter u-textColorWhite',
    append: '',
    hover: '',
  },
}

const sharedColorMap = {
  backgroundColor: '',
  textColor: '',
  secondaryColor: '',
  contentColor: '',
  buttonColor: 'u-textColorBrandLight',
  buttonClass: 'u-bgColorBrandDark u-textColorWhite u-border0',
  itemBackgroundColor: '',
  topMargin: 'u-marginVert12gu',
  line: '',
  hover: 'u-posRelative hover-underline-animation',
  arrow: 'brand',
}

export const colorMap = {
  None: {
    ...sharedColorMap,
    line: 'u-decoBorderLight u-decoBorderResetTop',
  },
  Brand: {
    ...sharedColorMap,
    backgroundColor: 'u-bgColorBrandDark',
    textColor: 'u-textColorWhite',
    secondaryColor: 'u-textColorWhite',
    contentColor: 'u-textColorWhite',
    buttonColor: 'u-textColorWhite',
    buttonClass: 'Button--reversed',
    hover:
      'u-posRelative hover-underline-animation hover-underline-animation-white',
    arrow: 'white',
  },
  'Brand Light': {
    ...sharedColorMap,
    textColor: 'u-textColorWhite',
    backgroundColor: 'u-bgColorBrandExtraLight',
  },
  Black: {
    ...sharedColorMap,
    backgroundColor: 'u-bgColorDark',
    textColor: 'u-textColorWhite',
    secondaryColor: 'u-textColorWhite',
    contentColor: 'u-textColorWhite',
    buttonColor: 'u-textColorWhite',
    buttonClass: 'Button--reversed',
    hover:
      'u-posRelative hover-underline-animation hover-underline-animation-white',
    arrow: 'white',
  },
  White: {
    ...sharedColorMap,
    backgroundColor: 'u-bgColorWhite',
    textColor: 'u-textColorBrandLight',
    secondaryColor: 'u-textColorBrandLight',
    contentColor: '',
    buttonClass: '',
    line: 'u-decoBorderLight u-decoBorderResetTop',
  },
  'Transparent White': {
    ...sharedColorMap,
    backgroundColor: '',
    textColor: 'u-textColorWhite',
    secondaryColor: 'u-textColorWhite',
    contentColor: 'u-textColorWhite',
    buttonColor: 'u-textColorWhite',
    buttonClass: 'Button--reversed',
  },
  'Gray Light': {
    ...sharedColorMap,
    backgroundColor: 'u-bgColorLight',
    contentColor: '',
    buttonClass: '',
    topMargin: '',
  },
  'Pale Blue': {
    ...sharedColorMap,
    backgroundColor: 'u-bgColorPaleBlue',
    textColor: 'u-textColorBrand',
    buttonClass: '',
  },
}

export const getColor = (keys) => {
  if (!keys) {
    return
  }

  if (keys.indexOf('equity') > -1) {
    return 'u-bgColorBeyonce'
  }

  if (keys.indexOf('fixed-income') > -1) {
    return 'u-bgColorAdele'
  }

  if (keys.indexOf('multi-asset') > -1) {
    return 'u-bgColorCher'
  }

  if (keys.indexOf('international') > -1) {
    return 'u-bgColorDuff'
  }

  if (keys.indexOf('alternatives') > -1) {
    return 'u-bgColorBrandExtraLight'
  }
}

// TODO: Contains hardcoded URLs -- see Metamenu component
export const getKeyPage = (keys) => {
  if (!keys) {
    return
  }

  if (keys.indexOf('equity') > -1) {
    return { name: 'Equity', url: '/what-we-offer/strategies-solutions/equity' }
  }

  if (keys.indexOf('fixed-income') > -1) {
    return {
      name: 'Fixed Income',
      url: '/what-we-offer/strategies-solutions/fixed-income',
    }
  }

  if (keys.indexOf('multi-asset') > -1) {
    return {
      name: 'Multi-Asset',
      url: '/what-we-offer/strategies-solutions/multi-asset',
    }
  }

  if (keys.indexOf('international') > -1) {
    return {
      name: 'Global Investment Solutions',
      url: '/what-we-offer/strategies-solutions/global-investment-solutions',
    }
  }
}
